import { render, staticRenderFns } from "./TabHistoryRefund.vue?vue&type=template&id=b8f0ecdc&scoped=true&"
import script from "./TabHistoryRefund.vue?vue&type=script&lang=js&"
export * from "./TabHistoryRefund.vue?vue&type=script&lang=js&"
import style0 from "./TabHistoryRefund.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TabHistoryRefund.vue?vue&type=style&index=1&id=b8f0ecdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f0ecdc",
  null
  
)

export default component.exports